
import { mapState, mapActions } from 'vuex';
import i18n from '@/lib/i18n';

export default {
  name: 'TheDialog',
  computed: {
    ...mapState('session', ['sessionParams'])
  },
  created() {
    this.initWindowService();
    const query = this.$route.query;
    if (query.locale) i18n.locale = query.locale;
    this.setSessionParams(query);
    this.initApi({
      brandCode: this.$route.params.brand_code,
      sessionParams: this.sessionParams
    });
    this.fetchTranslations(query.locale);
  },
  methods: {
    ...mapActions(['initApi']),
    ...mapActions('window', ['initWindowService']),
    ...mapActions('session', ['setSessionParams']),
    ...mapActions('translation', ['fetchTranslations'])
  }
};
